const settingsConfig = {
  layout: {
    style: 'layout1', // layout1 layout2 layout3
    config: {
      navbar: {
        display: true,
        style: 'style-2',
        folded: false
      }
    }
  },
  customScrollbars: true,
  direction: 'ltr', // rtl, ltr
  theme: {
    main: 'turpLight',
    navbar: 'turpLight', // 'greyDark'
    toolbar: 'turpLight', // 'mainThemeLight',
    footer: 'turpLight' // 'mainThemeDark'
  }
};

export default settingsConfig;
